import { Typography } from '@mui/material'

import { LoadingButton } from 'components/mui'

import useTrayMap from 'views/SPDLayout/SPD/TrayMap/TrayMap.logic'
import { useSPDScan } from 'views/SPDLayout/SPD/Scan/Scan.context'
import { useSPD } from 'views/SPDLayout/SPD/SPD.context'

import './LoadMultipleScrewsBox.scss'
import useGrayScaleLogic from '../GrayScale/GrayScale.logic'
import { TrayType } from '../EditTrayModal/EditTrayModal.types'

export const LoadMultipleScrewsBox = ({
  open,
  trayType,
}: {
  open: boolean
  trayType: TrayType
}) => {
  const { selectedScrewIndices } = useSPD()
  const { productData } = useSPDScan()
  const { handleCancelScrewsSelection } = useTrayMap()
  const { handleMultiSelectConfirm } = useGrayScaleLogic({
    trayType,
  })

  const asset = productData[0]

  return (
    <div className={`load-multiple-screws_box ${open ? 'open' : ''}`}>
      <Typography variant="h3" className="device-description">
        {asset?.deviceDescription}
      </Typography>

      <Typography variant="body1" className="device-description">
        {selectedScrewIndices.length} /{asset?.deviceCount} screws selected
      </Typography>

      <div className="confirmation_buttons-container">
        <LoadingButton
          disabled={false}
          loading={false}
          variant="outlined"
          mode="cancel"
          onClick={handleCancelScrewsSelection}
        >
          Cancel
        </LoadingButton>

        <LoadingButton
          variant="contained"
          disabled={false}
          loading={false}
          onClick={handleMultiSelectConfirm}
        >
          Confirm
        </LoadingButton>
      </div>
    </div>
  )
}
